import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { VendorOAuthRegistrationUser } from '../shared-emails/Integration/model/models';
import { Observable, Subject } from 'rxjs';
import { AccountUserService } from 'src/app/service/account.service';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {

  appUrl = "";
  activity = "";
  activityAPI = "";
  user: any;
  constructor(private http: HttpClient, private accountUserService: AccountUserService) {
    this.accountUserService.user.subscribe(x => this.user = x);
    this.appUrl = environment.apiUrl;
    this.activity = environment.localApiUrl;
    this.activityAPI = environment.activity;
  }

  getAllObjects() {
    return this.http.get(environment.configUrl + "LionO360_Object")
      .toPromise()
      .then(res => res);
  }

  getAllObjectTasks(objectID: number, objectTypeID: number, stageId?: number, channelId?: number) {
    return this.http.get(environment.activity + "/LionO360/2.0/API/ObjectTask/AllTask?", {
      params: new HttpParams().append("objectId", objectID.toString()).append("objectTypeId", objectTypeID.toString()).append("stageId", stageId?.toString()).append("channelId",channelId?.toString())
    })
      .toPromise()
      .then(res => res);
  }

  getAllObjectEvents(objectID: number, objectTypeID: number) {
    return this.http.get(`${this.activityAPI}/LionO360/2.0/API/ObjectCalendarEvent?objectId=${objectID}&objectTypeId=${objectTypeID}`,)
      .toPromise()
      .then(res => res);
  }

  getAllObjectNotes(objectID: number, objectTypeID: number) {
    return this.http.get(this.appUrl + "ObjectNote", {
      params: new HttpParams().append("objectId", objectID.toString()).append("objectTypeId", objectTypeID.toString())
    })
      .toPromise()
      .then(res => res);
  }

  getAllObjectLogs(objectID: number, objectTypeID: number) {
    return this.http.get(this.appUrl + "ObjectLog", {
      params: new HttpParams().append("objectId", objectID.toString()).append("objectTypeId", objectTypeID.toString())
    })
      .toPromise()
      .then(res => res);
  }

  getAllObjectEmailAudits(objectID: number, objectTypeID: number) {
    return this.http.get<any>(this.activity + "ObjectEmailAudit").toPromise().then(res => res);
    // , {
    //   params: new HttpParams().append("objectId", objectID.toString()).append("objectTypeId", objectTypeID.toString())
    // }
  }

  getTaskDetails(taskId) {
    return this.http.get(environment.activity + "/LionO360/2.0/API/Task/" + taskId)
      .toPromise()
      .then(res => res);
  }

  getNoteDetails(noteId) {
    return this.http.get(this.appUrl + "Note/" + noteId)
      .toPromise()
      .then(res => res);
  }

  getLogDetails(logId) {
    return this.http.get(this.appUrl + "Log/" + logId)
      .toPromise()
      .then(res => res);
  }

  getEmailAuditDetails(emailId) {
    return this.http.get(this.activity + "ObjectEmailAudit/" + emailId)
      .toPromise()
      .then(res => res);
  }

}
